<modal-error [showCloseButton]="false" (close)="closeModal()"  class="checkin-modal" title="Check-In">
  <p><b>IMPORTANTE: REALIZA EL CHECK-IN ANTES DE LLEGAR A TU ALOJAMIENTO</b></p>
  <p class="warning"><b>Faltan por registrar {{ pendingHostsCounts }} huéspedes</b></p>
  <p>Puedes reenviar el mensaje con el código de huésped a tus compañeros de viaje para que realicen el registro desde
    su móvil.</p>
  <menu-buttons [topActions]="checkinActions" (actionClick)="onCheckinActionClick($event)"></menu-buttons>
</modal-error>
